<li *ngFor="let item of listItemData" class="pv0 list-item">
  <div *ngIf="!item.href" class="klarheit body charcoal">
    {{ item.title }}
  </div>
  <a
    *ngIf="item.href"
    jbStandaloneLink
    [jbSitemapLinker]="item.href"
    [target]="item.newWindow"
    class="copy"
  >
    {{ item.title }}
  </a>
</li>
